// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"p5-z"};